import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';

export type TermsOfServiceForms =
  | 'Accept Invite'
  | 'Account Setup'
  | 'Application Account Info'
  | 'Modal';

export const useTermsOfServiceAnalytics = (formName: TermsOfServiceForms) => {
  const { currentUser } = useCurrentUser();
  const analytics = useAnalytics();

  const metadata = {
    form: formName,
    professional_id: currentUser?.professional?.id,
  };

  return {
    trackCompleted: () => analytics.track('Professional Terms of Service Completed', metadata),
    trackViewed: () => analytics.track('Professional Terms of Service Viewed', metadata),
  };
};
